import { CSSResultGroup, html, TemplateResult } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { paymentMethodSelectable } from 'components/ordering/checkout/payment-methods/payment-methods.style.js'
import {
  CSCMolliePaymentMethod,
  PaymentMethodState
} from 'components/ordering/checkout/payment-methods/methods/payment-method.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { GenericStartMolliePaymentPayload, } from 'components/ordering/checkout/payment-methods/payment-backend/start-payment-api.js'


export interface TrydentMollieGenericData {
  id: string,
  description: string,
  image_url: string
}


@customElement('csc-mollie-generic')
export class CSCMollieGeneric extends CSCMolliePaymentMethod {
  static override styles: CSSResultGroup = [hostStyle, paymentMethodSelectable]

  @property({ attribute: 'payment-method-id', reflect: true })
  paymentMethodId: string

  @state() protected readonly customDescription: string | null
  @state() protected state: PaymentMethodState

  @state() private readonly description: string
  @state() private readonly imageUrl: string
  private readonly payloadDataClassType: GenericStartMolliePaymentPayload

  constructor(
    { id, description, image_url }: TrydentMollieGenericData,
    state: PaymentMethodState,
    customDescription: string | null,
    payloadDataClassType: GenericStartMolliePaymentPayload,
  ) {
    super()

    this.paymentMethodId = id
    this.state = state
    this.customDescription = customDescription

    this.description = description
    this.imageUrl = image_url
    this.payloadDataClassType = payloadDataClassType
  }

  protected renderPaymentMethodContent = (): TemplateResult => {
    return html`
      <div class="selectable-content">
        <cse-image
          source="${this.imageUrl}"
          alt="${this.description}"
          width="55"
          height="41"
        >
        </cse-image>
        <cse-text>${this.description}</cse-text>
      </div>
    `
  }

  protected getPayload = async (): Promise<GenericStartMolliePaymentPayload> => {
    return this.payloadDataClassType
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'csc-mollie-generic': CSCMollieGeneric,
  }
}
